import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import { api_host, api_auth } from '../../../../../common/globals/constants';

import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
import { reportFetchError } from '../../../../../observability/rum';
moment.locale('es')

class AvailabilityGeneral extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptions: this._chartOptionsBase,
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
        }     
    }
    _chartOptionsBase = {
        chart: {
            type: 'column',
        },
        title: {
            text: '',
            style: {
                fontSize: '' 
             }
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: ''
            }
        },
        xAxis: {
            categories: [''],
            labels: {
                rotation: -45,
                //enabled: false
            },
            title: {
                text: null,
            },
            gridLineWidth: 0,

        },
        yAxis: {
            min: 0,
            max: 100,
            title: {
                text: null,
            },
            labels: {
                enabled: false
            },
            gridLineWidth: 0,

        },
        legend: {
            enabled: false
        },

        series: [
        ],
        tooltip: {
            enabled: false,
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    style: {
                        textOutline: 'none'
                    }
                }
            }
        },
    }

    setHoverData = (e) => {
        const { x, y, series } = e.target

        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = ""
        point['y'] = y
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptions: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod } = this.props.params
        const { history } = this.props;
        // puede necesitar agregar el schedule, guiarse por AvailabilityConsolidated
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/getDisponibilityCustom/?user=${user}&key=${api_auth}&objetivoId=${objetivo_id}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&token=${token}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('HTTP error ' + response.status);
                    }
                    return response.json();
                })
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                })
                .catch(error => {
                    reportFetchError('AvailabilityGeneral', error);
                    this.setState({ dataError: true, data: null, isLoading: false });
                });
        } else {
            fetch(api_host+`/reporte/online/indicadores/getDisponibility/?user=${user}&key=${api_auth}&objetivoId=${objetivo_id}&t=${period}&token=${token}`)
                .then(response => {
                    if(response.status!==200){
                        this.setState({
                            dataError: true,
                            data: null,
                            isLoading: false
                        });
                    }else{
                        response=response.json()
                        .then(myJson => {
                            // Se define el state de acuerdo a la petición y respuesta de la promesa 
                            if (myJson.status == 1 || myJson.status == 5) {
                                localStorage.setItem('isAuthenticated', false);
                                this.setState({ dataError: true, data: null, isLoading: false });
                            } else {
                                //Procesa la Data Recibida
                                try {
                                    this.processData(myJson, sla_rendimiento_ok,
                                        sla_rendimiento_error,
                                        sla_disponibilidad_ok,
                                        sla_disponibilidad_error,
                                        period,
                                        fecha_inicio,
                                        fecha_termino)
                                    if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                        this.props.params.onFirstInfo(this.state.lastEvent)
                                    }
                                } catch (error) {
                                    this.setState({
                                        dataError: true,
                                        data: null,
                                        isLoading: false
                                    });
                                }
                            }
        
                        });
                    }
                })
                .catch(error => {
                    reportFetchError('AvailabilityGeneral', error);
                    this.setState({ dataError: true, data: null, isLoading: false });
                })
                

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {

        const { data, final } = externalData
        let lastEventDict = []

        let dateJson = (new Date(final))
        let year = dateJson.getFullYear()
        let month = dateJson.getMonth()
        let day = dateJson.getDate()
        let hours = dateJson.getHours()
        let minutes = dateJson.getMinutes()
        let seconds = dateJson.getSeconds()
        //lastEventDict['x'] = Date.UTC(year,(month),day,hours,minutes,seconds)
        lastEventDict['x'] = ""
        lastEventDict['y'] = data.uptime + data['evento_cliente'] + data['marcado_atentus'];
        lastEventDict['name'] = 'uptime';
        if (period === 'h') {
            lastEventDict['namePeriod'] = 'Rango: última hora'
        } else if (period === 'd') {
            lastEventDict['namePeriod'] = 'Rango: último día'
        } else if (period === 'w') {
            lastEventDict['namePeriod'] = 'Rango: última semana'
        } else if (period === 'c') {
            lastEventDict['namePeriod'] = 'Rango: ' + fecha_inicio + ' a ' + fecha_termino
        }
        let chartDataUptime = [data.uptime + data['evento_cliente'] + data['marcado_atentus']]
        let chartDataDowntime = [data.downtime]
        let chartDataParcial = [data.parcial]
        let chartDataNoMon = [data['no monitoreo']]

        this.setState({
            chartOptions: {
                plotOptions: {
                    series: {
                        point: {
                            events: {
                                mouseOver: this.setHoverData.bind(this)
                            }
                        }
                    }
                },

                series: [
                    {
                        name: 'Uptime',
                        color: '#41B900',
                        data: chartDataUptime
                    },
                    {
                        name: 'Downtime',
                        color: '#C2272D',
                        data: chartDataDowntime
                    },
                    {
                        name: 'Parcial',
                        color: '#FFC600',
                        data: chartDataParcial
                    },
                    {
                        name: 'No Monitoreo',
                        color: '#A9A9A9',
                        data: chartDataNoMon
                    }
                ]
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            chartOptionsBase: {
                ...this._chartOptionsBase,
                series: [
                    {
                        name: 'Uptime',
                        color: '#41B900',
                        data: chartDataUptime
                    },
                    {
                        name: 'Downtime',
                        color: '#C2272D',
                        data: chartDataDowntime
                    },
                    {
                        name: 'Parcial',
                        color: '#FFC600',
                        data: chartDataParcial
                    },
                    {
                        name: 'No Monitoreo',
                        color: '#A9A9A9',
                        data: chartDataNoMon
                    }
                ]
            }
                        
        });

    }
    render() {
        const { dataError, chartOptions, isLoading ,chartOptionsBase} = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        if (!dataError) {
            sessionStorage.setItem("chartAvailabilityGeneral",JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} />)
        }
        else if (dataError) {
            return (<p>Sin datos.</p>)
        }
        else return (<p>Error!</p>)

    }
}

function FormattedChart(props) {
    return (
        <div >
            <div style={props.styleHidden}>
            <PortletContent>
                <PerfectScrollbar>

                    <Typography
                      variant="h5"
                    >
                     <CircularProgress
                      variant="indeterminate"

                      size={24}
                      thickness={4}
                      
                    />
                    <br/>
                     Cargando Información...
                   </Typography>
                  </PerfectScrollbar>
            </PortletContent>
            </div>
            <div style={props.style}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={props.chartOptions} />
            </div>
        </div>
    )
}


export default withRouter(AvailabilityGeneral);